module.exports = __webpack_public_path__ + "img/guide_06.50ceb53d.png";